@if (isShown()) {
  <img @pinwheel-animation alt="" src="assets/images/pngs/pinwheel.png" />
}
